function Square2(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><g><rect width="480" height="480" rx="120" ry="120"></rect></g></svg>
    )
}

export default Square2